import AgreementStudio from "./AgreementStudio";
import { useStoreActions } from "../../contexts";
import RestfulWrapper from "../RestfulWrapper/RestfulWrapper";
import { routes } from "../../constants";
import { jsx as _jsx } from "react/jsx-runtime";
export default function RelationshipDraftFetcher(props) {
  const {
    api
  } = useStoreActions();
  const {
    draftId
  } = props.match.params;
  return /*#__PURE__*/_jsx(RestfulWrapper, {
    fetch: () => api.draft.getById(draftId),
    renderChild: _ref => {
      let {
        data
      } = _ref;
      return /*#__PURE__*/_jsx(AgreementStudio, {
        draft: data,
        returnRoute: routes.draftsDashboard
      });
    }
  });
}